module.exports = __webpack_public_path__ + "static/img/主会场学术报告.806c79b9.jpg";